export const formatAxiosErrorForSentry = error => {
  const formattedError = {
    status: error?.response?.status,
    statusText: error?.response?.statusText,
    url: error?.config?.url,
    method: error?.config?.method?.toUpperCase(),
    requestData: error?.config?.data,
    responseData: error?.response?.data,
  }

  return JSON.stringify(formattedError)
}
